<template lang="pug">
div.lp-wrapper
  slot(name="reasontype", :reason="reason")
    p.radio-group 落地页优化筛选：
      v-radio-group(
          v-model = "reason.currentReason",
          :name = "'reason'",
          :options = "reason.reasonList"
        )
    div.content-tip
      .label 说明：
      .control 
         p  1、 跳出率高的页面，请查看页面与搜索意图是否匹配，或者使用“热力图”功能对页面进行深入分析
         p  2、其他转化率较低页面，可能由到达率低或者其他原因导致，请配合使用“路径分析”功能查看用户主要流失步骤
  .advice-table.lp-opt-table
    HeadFixedTable(
      :columns = "currentColumns",
      :checkbox="hasCheckbox",
      :check_all="hasCheckbox",
      :checkbox_length="9000",
      :hasPagination = "true",
      :list = "currentList"
      )
      template(slot="delete-td" scope="props")
          slot(name="delete", :item="props.item")
      template(slot="status-td" scope="props")
          slot(name="status", :item="props.item")

</template>
<script>
import HeadFixedTable from '../../component/fold-table.vue'
import Mixin from '../mixin.js'

export default {
  mixins: [Mixin],
  components: {
      HeadFixedTable,
  },
  props: {
    extendColumns: {
      type: Array,
      default() {
        return  []
      }
    },
    hasCheckbox: {
      type: Boolean,
      default: true
    },
    list: {
      type: [Array, Object],
      default() {
        return [{
          "domainId": 1011,
          "trate": 0.23,
          "arrive_tate": 0.66, 
          keyword: "页面",
          "landpage": "www.baidu.com",
          reason: 'arrive',
          reasonDesc: '跳出率高'
        }, {
          "domainId": 1012,
          "trate": 0.24,
          "arrive_tate": 0.67, 
          keyword: "页面",
          "landpage": "www.baidu.com",
          reason: 'other',
          reasonDesc: '其他'
        }]
      }
    }
  },
  watch: {
      adviceGroupObj() {
        this.updateReasonList()
      }
  },
  computed: {
    adviceGroupObj() {
      return _.extend({
          all: this.list
        }, _.groupBy(this.list, 'reason'))
    },
    currentList() {
      return this.adviceGroupObj[this.reason.currentReason] || []
    },
    currentColumns() {
      let list = []
        list = [{
          title: "落地页面URL",
          key: "landpage",
          render: this.textEllipsidRender
        },{
          title: "优化理由",
          key: "reasonDesc"
        },{
          title: "跳出率",
          key: "avg7jrate",
          render: this.percentRender
        },{
          title: "转化率",
          class: "right",
          key: "avg7trate",
          render: this.percentRender
        }]
      return _.concat(list, this.extendColumns)
    }
  },
  mounted() {
    this.updateReasonList()
    this.$set(this.reason, 'currentReason', this.reason.reasonList[0].value)
  },
  data() {
    return {
      reason: {
        currentReason: "",
        reasonList: []
      }
    }
  },
  methods: {
    updateReasonList() {
      let list = _.reduce(this.adviceGroupObj, (result, value, key) => {
        result.push({
          value: key,
          title: key == 'all' ? '全部优化页面' : value[0].reasonDesc
        })
        return result
      }, [])
      this.$set(this.reason, 'reasonList', list)
    }
  }

}
</script>
<style scoped>
.content-tip {
  margin: 10px 20px;
}
.control {
  display: inline-block;
}
.label {
  display: inline-block;
  width: 50px;
  vertical-align: top;
}
.modal-bd-wrapper .modal-table-wrapper .advice-table{
    border: 1px solid #DADFE6;
    border-top: none;
}
.content-tip .control p:first-child{margin-bottom: -10px;}
.content-tip .control p:last-child{margin-bottom: 0px;line-height: 2.5}
</style>



// WEBPACK FOOTER //
// lp_advice_table.vue?7982ee62